<script setup lang="ts">
import { computed } from "vue";
import { useQuoteStore } from "@/stores/quotes";
import { getSessionId, isBot } from "@/utils";
import { determineDevice } from "@/utils/devices";

const quoteStore = useQuoteStore();

const pixelData = computed(() => {
    const affiliate = quoteStore.getAffiliate();
    return {
        sessionId: getSessionId(),
        affiliateName: affiliate.name,
        affiliateNumber: affiliate.number.toString(),
        source: affiliate.source,
        device: determineDevice(navigator, screen),
    };
});
</script>

<template>
    <img
        v-if="!isBot()"
        :src="`/pixels/affiliate-visit?sessionId=${pixelData.sessionId}&affiliateName=${pixelData.affiliateName}&affiliateNumber=${pixelData.affiliateNumber}&source=${pixelData.source}&device=${pixelData.device}`"
        alt=""
        class="pixel"
    >
</template>
